"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
function Success(_a) {
    var title = _a.title, subtitle = _a.subtitle, returnUrl = _a.returnUrl, onClose = _a.onClose;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'storybook-forms-success-icon' },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'check', className: 'w-6 h-6 text-white' })),
        react_1.default.createElement("div", { className: 'storybook-forms-success' },
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, title),
            subtitle && react_1.default.createElement(storybook_1.Texts.Primary, null, subtitle)),
        react_1.default.createElement("div", { className: 'storybook-forms-success-buttons' },
            !!onClose && react_1.default.createElement(storybook_1.Buttons.Button, { type: 'light', onClick: onClose, outline: true }, "Doorgaan"),
            !!returnUrl && react_1.default.createElement(storybook_1.Buttons.Link, { type: 'primary', to: returnUrl }, "Naar dashboard"))));
}
exports.default = Success;
Success.propTypes = {
    /**
     * The title
     */
    title: prop_types_1.default.string.isRequired,
    /**
     * The subtitle
     */
    subtitle: prop_types_1.default.string,
    /**
     * The 'to dashboard' button
     */
    returnUrl: prop_types_1.default.string,
    /**
     * The continue button
     */
    onClose: prop_types_1.default.func,
};
Success.defaultProps = {
    title: 'Je actie is succesvol doorgevoerd',
};
